import React from 'react';
import { ServiceLogPage } from '@warehouse/service-log/feature-service-log';

export function ServiceLog() {
	return <ServiceLogPage />;
}
